import React from 'react';

const ZeroResults = ({ searchTerm }) => {
    const headline = searchTerm ? (
        <h2 className="h4">
            Din sökning <strong>{searchTerm}</strong> matchade inte någon
            annons.
        </h2>
    ) : (
        <h2 className="h4">Din sökning matchade inte någon annons.</h2>
    );
    return (
        <article data-zero-results className="card col-12 p-5">
            {headline}
            <h3 className="h6 pb-2 pt-3">
                <strong>Bevaka via mejl</strong>
            </h3>
            <p>
                Spara din sökning för att få ett mejl när det du sökt efter
                läggs upp.
            </p>
            <h3 className="h6 pb-2">
                <strong>Tips för bättre sökresultat</strong>
            </h3>
            <ul>
                <li>Dubbelkolla att du är i rätt kategori när du söker</li>
                <li>
                    {`Använd citationstecken för att få träffar på exakt fras, ex
                    "Polarn och Pyret"`}
                </li>
                <li>
                    Använd asterisk när du vill bredda din sökning, ex ger
                    frimärk* träffar på frimärke, frimärksalbum etc
                </li>
            </ul>
            <a
                href="http://info.tradera.com/soktips/"
                className="link search-result-empty-read-more"
                data-ga-category="Search"
                data-ga-action="Navigation"
                data-ga-label="Read more search tips">
                Fler söktips
            </a>
        </article>
    );
};

export default ZeroResults;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/zero-results.jsx